<template>
    <div>
        <SectionList title="International Codes (I-Codes) and Supplements" icon="mdi-web" :items="iCodeCategories" />
        <SectionList title="Codes by Location" icon="mdi-map-marker-outline" :items="locationCategories" />
        <SectionList title="Standards, Topics and More" icon="mdi-bank-outline" :items="moreCategories" />
        <SectionList
            title="Recently Added Titles"
            icon="mdi-bullhorn-outline"
            :items="recentlyAddedTitles"
            :hideDivider="true"
            :displayTitlesView="true"
            :loadingTitles="loadingTitles" />
    </div>
</template>

<script>
import SectionList from './SectionList.vue';
import { TitlesApi } from '../../api/Titles';

export default {
    components: { SectionList },
    data() {
        return {
            iCodeCategories: [
                { title: 'I-Codes', url: `${this.getRoute('codes')}/i-codes`},
                { title: 'Commentaries', url: `${this.getRoute('codes')}/commentaries`},
                { title: 'Resources', url: `${this.getRoute('codes')}/resources` }
            ],
            locationCategories: [
                { title: 'United States', url: `${this.getRoute('codes')}/united-states`},
                { title: 'Global', url: `${this.getRoute('codes')}/global`}
            ],
            moreCategories: [
                { title: 'Standards', url: `${this.getRoute('codes')}/standards`},
                { title: 'Publishers', url: `${this.getRoute('codes')}/publisher`},
                { title: 'Topics', url: `${this.getRoute('codes')}/topics`},
                { title: 'Collections', url: `${this.getRoute('codes')}/collections`}
            ],
            recentlyAddedTitles: [],
            loadingTitles: false
        }
    },
    methods: {
        async getRecentlyAddedTitles(){
            this.loadingTitles = true;
            const data = {
                page: 1,
                limit: 10,
                search: '',
                group: 'recently_added'
            };
            const response = await TitlesApi.getTitles(data);
            this.recentlyAddedTitles = response.data.data;
            this.loadingTitles = false;
        }
    },
    mounted() {
        this.getRecentlyAddedTitles();
    }
}
</script>